import React from "react";
// core components
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";

const initState = {
    selectList: null,
    error: null,
    loading: null,
}

const catalogoEstadosReducer = (state = initState, action) => {
    
    switch (action.type) {
        case "CATALOGO_ESTADOS_LIST_SELECT":
            return {
                ...state,
                selectList: action.payload.data,
                loading: null,
                error: null,
            }       
        case "CATALOGO_ESTADOS_ERROR":
            return {
                ...state,
                error: action.payload.error,   
                loading: null,                     
            }
        case "CATALOGO_ESTADOS_LIMPIAR_MENSAJES": {
            return {
                ...state,
                error: null,
            }
        }            
        case "CATALOGO_ESTADOS_LOADING": {
            return {
                ...state,
                loading: (<CustomLinearProgress color="info" />),
            }
        }                        
        default:
            return state;
    }
}

export default catalogoEstadosReducer;